__webpack_require__.p = "/kothari-mobile-zone/";